<template>
  <main class="wrapper-content pr-0" style="padding-left: 15px">
    <!-- Loading -->
    <LmComponentLoading v-if="isLoading" fixed />
    <LmPeopleSearcher
      v-if="!isOnEditMode"
      ref="peopleSearcher"
      @onSelect="onInitiatorSelect"
      @onSearcherPersonData="personIdentifierData = $event"
    />
    <b-row>
      <b-col>
        <template v-if="isOnEditMode">
          <h1>{{ form.processName }}</h1>
          <LmProcessResume
            v-if="resumeContentLoaded"
            :data="form"
            :actions="actionsAvailable"
            @onEditProcess="enableToEdit = true"
            @onNewPass="$refs.toolbar.toolbarMode = 'processPasses'"
            @onChangeStatus="$refs.toolbar.toolbarMode = 'processStatus'"
            @onUpdatePerson="form.processStarter = $event"
            @onUpdateInitiator="onUpdateInitiator"
            @onLinkProcess="$refs.toolbar.toolbarMode = 'processLink'"
            @onRemoveProvessLink="onRemoveProvessLink"
          />
        </template>
        <div v-show="!isOnEditMode || enableToEdit">
          <portal to="processSubTitle" v-if="!isOnEditMode">
            <b-col cols="12" class="px-0">
              <b-card
                title="Iniciador"
                class="border shadow-sm bg-light"
              >
                <template v-if="form.processStarter">
                  <b-card-text>Tipo: {{ form.processStarter.starterType === 'people' ? 'Persona' : 'Iniciador' }}</b-card-text>
                  <b-card-text>
                    Nombre: {{ form.processStarter.name }}
                    <template v-if="personIdentifierData">
                      - {{ personIdentifierData.personIdType.name }}: {{ personIdentifierData.personId }}
                    </template>
                  </b-card-text>
                </template>
                <div class="d-flex" style="gap: 15px">
                  <LmButton
                    v-if="form.processStarter"
                    value="Ver detalles"
                    @click="onStarterDetails"
                  />
                  <LmButton
                    value="Cambiar iniciador"
                    @click="onSearchStarter"
                  />
                </div>
              </b-card>
            </b-col>
          </portal>
          <portal to="processName">
            <!-- Input del nombre -->
            <LmTextInput
              class="col-12 px-0"
              v-model="$v.form.processName.$model"
              :v="validation('form.processName')"
              :label="$t('name')"
              :placeholder="$t('name')"
              :disabled="isOnEditMode"
            />
          </portal>
          <portal to="processAddress">
            <!-- Input de la dirección -->
              <LmTextInput
                v-if="form.processStarter && form.processStarter.starterType !== 'initiator'"
                :disabled="isOnEditMode"
                class="col-12 px-0"
                v-model="$v.form.processAddress.$model"
                :v="validation('form.processAddress')"
                :label="$t('address')"
                :placeholder="$t('address')"
              />
          </portal>
          <!-- Formbuilder Server Components -->
          <LmFormBuilder
            :formTitle="pageTitle"
            class="px-0 mb-2"
            v-if="formbuilderId && !deleted"
            ref="lmFormbuilder"
            :endpointUriwhereGetComponents="formbuilderPath"
            :endpointUriWhereGetValuesToLoadInEditMode="dataPathOnEditMode"
            :formValues="dataToPersist"
            :contentTemplateData="form"
            @formObjectToSendToServerChange="updateForm($event)"
          />
        </div>

        <b-card no-body class="border" v-if="actionsAvailableComputed.processCanAddDocuments">
          <b-tabs card>
            <b-tab title="Documentos BUDD" active v-if="actionsAvailable.processCanAllowMeToAddDocuments">
              <b-row>
                <b-col md="4" cols="12">
                  <LmButton
                    buttonClass="btn-info btn-block"
                    value="Buscar existente"
                    v-b-modal.documents-datatable-modal
                  />
                  <LmButton
                    buttonClass="btn-primary btn-block"
                    value="Crear nuevo"
                    v-b-modal.document-types-datatable-modal
                  />
                </b-col>
                <b-col md="8" cols="12">
                  <b-list-group v-if="form.documents.length">
                    <b-list-group-item
                      v-for="(doc, index) in form.documents"
                      :key="doc.id"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <b-button
                        class="my-0"
                        variant="link"
                        size="sm"
                        @click="onShowDocumentPdf(doc.id)"
                      >
                        {{ doc.name }}
                      </b-button>
                      <font-awesome-icon class="trash-icon clickable" icon="trash" @click="onRemoveDocument(index)" />
                    </b-list-group-item>
                  </b-list-group>
                  <div v-else>
                    <LmSvgIcon
                      icon="LmNoDataIcon"
                      width="7.5em"
                      wrapperClass="mb-4 d-flex justify-content-center"
                    />
                    <p class="text-center">
                      No hay documentos asignados a este trámite.
                    </p>
                  </div>
                </b-col>
              </b-row>
              <b-modal
                id="documents-datatable-modal"
                size="xl"
                @ok="onConfirmDocumentsBUDD"
                :cancel-title="$t('cancel')"
                :ok-title="$t('confirm')"
              >
                <LmDataTable
                  @onSelect="onSelectDocuments"
                  slug="documentos-seleccionables-para-budd"
                  hideButtons
                />
              </b-modal>
              <b-modal
                id="document-types-datatable-modal"
                size="xl"
                :cancel-title="$t('cancel')"
                :ok-title="$t('confirm')"
              >
                <LmDataTable
                  @onSelect="onSelectDocuments"
                  slug="tipos-de-documento-todos"
                  hideButtons
                />
              </b-modal>
            </b-tab>
            <b-tab title="Documentos internos" v-if="actionsAvailable.processCanAllowMeToAddInternalDocuments">
              <LmUploadFiles
                class="col-12"
                label="Subir documentos"
                duplicateCheck
                v-model="form.internalDocuments"
                :dropzoneOptions="{
                  acceptedFiles: acceptedInternalsDocuments,
                  headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null
                  },
                  withCredentials: true,
                  thumbnailWidth: 150,
                  maxFilesize: 5,
                  timeout: 120000,
                  addRemoveLinks: true,
                  maxFiles: null,
                  clickable: true
                }"
              />
            </b-tab>
          </b-tabs>
        </b-card>
        <b-modal
          id="document-preview-modal"
          :title="documentPdf ? documentPdf.name : 'Documento'"
          size="xl"
          hide-footer
        >
          <div v-if="!documentPdf" class="preview-iframe">
            <LmComponentLoading />
          </div>
          <iframe
            v-else
            :src="documentPdf.src"
            frameborder="0"
            width="100%"
            class="preview-iframe"
          ></iframe>
        </b-modal>
      </b-col>
      <!-- Toolbar -->
      <LmToolbar
        ref="toolbar"
        :isOnEditMode="isOnEditMode"
        :items="toolbarItems"
        :config="toolbarConfig"
        @onProcessStatusChange="onProcessStatusChange"
        @onProcessPassChange="onProcessPassChange"
        @onContentTemplateChange="onContentTemplateChange"
        @onAddLinkedProcesses="onAddLinkedProcesses"
      />
    </b-row>

    <!-- Action Buttons -->
    <b-row>
      <LmButton
        v-if="!showGoBackButton"
        :value="$t('cancel')"
        class="col-auto"
        type="button"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        v-if="showGoBackButton"
        value="Volver"
        class="col-auto"
        type="button"
        buttonClass="btn-secondary"
        @click="$router.go(-1)"
      />
      <LmButton
        v-if="showRejectButton"
        :value="$t('reject')"
        class="col-auto"
        type="button"
        buttonClass="btn-danger"
        @click="onReject"
        requireConfirmation
        confirmationTitle="Rechazar trámite"
        confirmationMessage="¿Estas seguro de que deseas rechazar este trámite?"
      />
      <LmButton
        v-if="showSaveButton"
        :value="$t('save')"
        class="col-auto"
        type="button"
        buttonClass="btn-primary"
        @click="onSubmit({withPass: false})"
      />
      <LmButton
        v-if="showStartButton"
        :value="$t('start')"
        class="col-auto"
        type="button"
        buttonClass="btn-success"
        @click="onStartProcessModal"
      />
      <LmButton
        v-if="showTakeButton"
        value="Tomar"
        class="col-auto"
        type="button"
        buttonClass="btn-success"
        @click="onTakeProcess"
      />
      <LmButton
        v-if="showReOpenButton"
        value="Reabrir"
        class="col-auto"
        type="button"
        buttonClass="btn-success"
        @click="onReOpenProcess"
      />
    </b-row>
    <b-modal
      id="request-start-modal"
      title="Seleccione a quien soliciar iniciar el trámite"
      centered
      @ok="startProcess"
    >
      <LmTreeSelect
        label="Seleccione una opción"
        @input="passTo = null"
        v-model="requestStartType"
        :options="requestStartTypeOptions"
        @select="requestStartDestination = null"
      />
      <div v-if="requestStartType">
        <LmTreeSelect
          v-if="requestStartType.id === 'area'"
          clearable
          label="Área"
          :options="requestStartOptions.areas"
          v-model="requestStartDestination"
        />
        <LmTreeSelect
          v-if="requestStartType.id === 'subarea'"
          clearable
          label="Subárea"
          :options="requestStartOptions.subareas"
          v-model="requestStartDestination"
        />
        <LmTreeSelect
          v-if="requestStartType.id === 'user'"
          clearable
          label="Usuario"
          :options="requestStartOptions.users"
          v-model="requestStartDestination"
        />
      </div>
    </b-modal>
    <LmConfirmationModal
      ref="lmConfirmationModal"
      title="Confirmar acción"
      message="¿Desea iniciar el trámite?"
      @ok="startProcess"
    />
    <LmConfirmationModal
      ref="lmTakeConfirmationModal"
      title="Confirmar acción"
      message="Desea tomar el trámite?"
    />
  </main>
</template>

<script>
import LmDataTable from '@/components/lmDataTable/table'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { EventBus } from '@/event-bus.js'
import LmPeopleSearcher from '@/components/LmPeopleSearcher'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmProcessResume from '@/components/LmProcessResume'
import _ from 'lodash'

import LmToolbar from '@/components/lmToolBar'

import { mapMutations, mapGetters } from 'vuex'

import {
  required, requiredIf
} from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmDataTable,
    LmToolbar,
    LmFormBuilder,
    LmButton,
    LmTreeSelect,
    LmTextInput,
    LmConfirmationModal,
    LmPeopleSearcher,
    LmUploadFiles,
    LmProcessResume
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      requestStartType: null,
      requestStartTypeOptions: [{
        id: 'user',
        name: 'Usuarios'
      }, {
        id: 'area',
        name: 'Áreas'
      }, {
        id: 'subarea',
        name: 'Subáreas'
      }],
      requestStartDestination: null,
      enableToEdit: false,
      initialForm: '',
      personIdentifierData: null,
      documentPdf: null,
      requestType: null,
      requestTo: null,
      documentSelected: null,
      processTypeComments: '',
      processTypeHidecCommentsOnFinished: false,
      processTypeInstanceActions: null,
      requestStartOptions: {
        areas: null,
        subareas: null,
        users: null
      },
      formbuilderId: '',
      listbuilderId: '',
      processTypeId: '',
      processTypeName: null,
      published: false,
      deleted: false,
      lumbreStatusName: null,
      showPeopleSearcher: false,
      instanceStarters: {},
      actionsAvailable: {
        processCanBeStartedByMe: false,
        processCanBeRequestStartedByMe: false,
        processCanBeCreatedByMe: false,
        processCanBeTakenByMe: false,
        processCanAllowMeToAddDocuments: false,
        processCanAllowMeToAddInternalDocuments: false,
        processCanBeRejectedByMe: false,
        processCanBeChangedStatusByMe: false,
        processCanBeReOpenByMe: false
      },
      form: {
        processStarter: null,
        processName: '',
        processAddress: '',
        documents: [],
        initiatorFields: {},
        internalDocuments: []
      },
      documentsToAdd: [],
      resumeContentLoaded: false,
      isLoading: false,
      processHasAnyContent: false
    }
  },
  validations: {
    form: {
      processName: {
        required
      },
      processStarter: {
        required
      },
      processAddress: {
        required: requiredIf(function () {
          return this.form?.processStarter?.starterType === 'people'
        })
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler (val) {
        this.processHasAnyContent = true
      }
    }
  },
  computed: {
    ...mapGetters('processes', ['lastDocumentCreated', 'dataToPersist']),
    acceptedInternalsDocuments () {
      return [
        { id: 1, name: 'PDF' },
        { id: 2, name: 'DOC' },
        { id: 3, name: 'DOCX' },
        { id: 4, name: 'XLS' },
        { id: 5, name: 'XLSX' },
        { id: 6, name: 'TXT' },
        { id: 7, name: 'JPG' },
        { id: 8, name: 'PNG' }
      ]
    },
    actionsAvailableComputed () {
      return {
        processCanAddDocuments: this.actionsAvailable.processCanAllowMeToAddDocuments || this.actionsAvailable.processCanAllowMeToAddInternalDocuments
      }
    },
    showGoBackButton () {
      return this.$route?.params?.goBackButton || false
    },
    showSaveButton () {
      if (this.form.processStarter && ((!this.isOnEditMode && this.actionsAvailable.processCanBeCreatedByMe) || (this.isOnEditMode && this.actionsAvailable.processCanBeEditedByMe))) {
        return true
      }
      return false
    },
    showStartButton () {
      if (this.form.processStarter) {
        return (this.actionsAvailable.processCanBeStartedByMe || this.actionsAvailable.processCanBeRequestStartedByMe)
        // if (!this.actionsAvailable.processCanBeStartedByMe || !this.actionsAvailable.processCanBeRequestStartedByMe) {
        //   return false
        // }
        // return true
      }
      // Aun no se selecciono el iniciador del trámite y el trámite tampoco se creo.
      return false
    },
    showTakeButton () {
      if (this.isOnEditMode && this.actionsAvailable.processCanBeTakenByMe) {
        return true
      }
      return false
    },
    showReOpenButton () {
      if (this.isOnEditMode && this.actionsAvailable.processCanBeReOpenByMe) {
        return true
      }
      return false
    },
    showRejectButton () {
      return this.isOnEditMode && this.actionsAvailable.processCanBeRejectedByMe
    },
    contentTemplatePath () {
      return `/contenttemplate/${this.processTypeId}/processtypes/all`
    },
    pageTitle () {
      if (this.isOnEditMode) {
        return this.form.processName
      }
      return 'Nuevo trámite'
    },
    formbuilderPath () {
      return `/formbuilder/${this.formbuilderId}`
    },
    dataPathOnEditMode () {
      if (this.isOnEditMode) {
        return `/processes/${this.$route?.params?.id}`
      } else {
        return ''
      }
    },
    disableComments () {
      if (this.processTypeComments === 'always') {
        return false
      }
      if (this.processTypeComments === 'in_progress') {
        if (this.lumbreStatusName !== 'Finalizado') {
          return false
        }
        return true
      }
      return false
    },
    hideComments () {
      if (this.processTypeComments === 'in_progress' && this.lumbreStatusName === 'Finalizado' && this.processTypeHideCommentsOnFinished) {
        return true
      }
      if (this.processTypeComments === 'never') {
        return true
      }
      return false
    },
    toolbarItems () {
      let items = []
      if (this.isOnEditMode) {
        items = [
          'contentTemplates',
          'processHistory',
          'auditMovements',
          'processMovements',
          'allDocuments',
          'allInternalDocuments'
        ]
        if (this.actionsAvailable.processCanBeEditedByMe) {
          items.push(null)
          if (this.form?.lumbreStatus?.id === '3') {
            items.push('processLink')
          }
        }
        if (this.actionsAvailable.processCanAllowMeToAddMovements) {
          items.push('processPasses')
        }
        if (this.actionsAvailable.processCanBeChangedStatusByMe) {
          items.push('processStatus')
        }
        if (!this.hideComments) {
          items.unshift('comments')
        }
      } else {
        items = [
          'contentTemplates'
        ]
      }
      return items
    },
    toolbarConfig () {
      return {
        comments: {
          linkType: 'processes',
          disabled: this.disableComments
        },
        contentTemplates: {
          path: `/contenttemplate/${this.processTypeId}/processtypes/all`,
          template: this.form,
          reference: this.processTypeId
        },
        processHistory: {
          historyEndpoint: '/processes/history'
        },
        processMovements: {
          historyEndpoint: '/processes/movements'
        },
        allDocuments: {
          documentsEndpoint: '/processes/documents'
        },
        allInternalDocuments: {
          documentsEndpoint: '/processes/internaldocuments'
        },
        auditMovements: {
          serviceName: 'processes'
        },
        processLink: {
          linkedProcesses: this.form?.processRelationships
        }
      }
    }
  },
  methods: {
    ...mapMutations('processes', ['setDataToPersist', 'clearProcessesStore']),
    validation (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    async onSelectDocuments (event) {
      let documents = _.cloneDeep(this.form.documents)

      event = event.map(el => {
        return {
          id: el.id,
          name: el['document-number']
        }
      })

      documents = documents.concat(event)

      this.documentsToAdd = [...new Map(documents.map(item => [item.id, item])).values()]
    },
    onConfirmDocumentsBUDD () {
      this.form.documents = this.documentsToAdd
      this.documentsToAdd = []
    },
    async onProcessStatusChange (event) {
      this.form.lumbreStatus = event
      await this.loadActionsAvailable()
      await this.loadContentOnEditMode()
    },
    async onProcessPassChange (event) {
      this.form.lastMovement.destination = event
      await this.loadActionsAvailable()
      await this.loadContentOnEditMode()
    },
    async onAddLinkedProcesses () {
      this.$refs.toolbar.toolbarMode = null
      await this.loadActionsAvailable()
      await this.loadContentOnEditMode()
    },
    async onRemoveProvessLink (event) {
      this.form.processRelationships = this.form.processRelationships.filter(el => el.id !== event)
      if (!this.form.processRelationships.length) {
        await this.loadActionsAvailable()
        await this.loadContentOnEditMode()
      }
    },
    onInitiatorSelect (event) {
      if (event?.people) {
        this.form.processStarter = {
          id: event.people._id,
          name: event.people.personName,
          starterTypeId: event.people.starterTypeId,
          starterType: 'people'
        }
      }
      if (event?.initiator) {
        this.form.processStarter = {
          id: event.initiator.id,
          name: event.initiator.name,
          starterTypeId: event.initiator.starterTypeId,
          starterType: 'initiator'
        }
        this.form.initiatorFields = event.initiator.fields
      }
    },
    onUpdateInitiator (event) {
      this.form.processStarter = {
        id: event.id,
        name: event.name,
        starterTypeId: event.starterTypeId,
        starterType: event.starterType
      }
      this.form.initiatorFields = event.fields
    },
    onStarterDetails () {
      if (this.form.processStarter.starterType === 'people') {
        this.$refs.peopleSearcher.personDetails()
      } else {
        this.$refs.peopleSearcher.initiatorDetails()
      }
    },
    onContentTemplateChange (event) {
      for (const key in this.form) {
        if (event.hasOwnProperty(key)) {
          this.form[key] = event[key]
        }
      }
    },
    onRemoveDocument (index) {
      this.form.documents.splice(index, 1)
    },
    async onShowDocumentPdf (id) {
      try {
        this.$bvModal.show('document-preview-modal')
        const doc = await commonsApi.axiosGetWrapper(`/documents/${id}`)
        this.documentPdf = doc.data.documentInPdf
      } catch (error) {
        console.log(error)
      }
    },
    validateStarter () {
      if (!this.form.processStarter) {
        this.lmToastDangerMessage('Debe elegir una persona iniciadora del trámite.', 'Error')
        throw new Error('Debe elegir una persona iniciadora del trámite.')
      }
    },
    async onReOpenProcess () {
      try {
        if (this.isOnEditMode) {
          await commonsApi.axiosPostWrapper('/processes/reopen', {
            id: this.$route.params.id
          })
          this.lmToastSuccessMessage(`Se reabrió correctamente el trámite ${this.form?.processName}.`, `Operación realizada con éxito.`)
          await this.loadActionsAvailable()
          await this.loadContentOnEditMode()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onSubmit (props) {
      try {
        this.isLoading = true
        if (props.withPass) {
          // mostrar modal
        }
        // Validaciones
        await this.validateForm(this.$v)
        await this.$refs.lmFormbuilder.validate()

        const dataToSendToServer = {
          ...this.form,
          processTypeId: this.processTypeId
        }
        if (!this.isOnEditMode) {
          // nuevo
          const res = await commonsApi.axiosPostWrapper('/processes/new', dataToSendToServer)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.processName || ' el trámite'} correctamente.`, 'Se guardó exitosamente')
          this.$router.replace(`/tramites/${res.data.processTypeId}/editar/${res?.data?._id}`)
        } else {
          // editar
          const res = await commonsApi.axiosPutWrapper(`/processes/edit/${this.$route?.params?.id}`, dataToSendToServer)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.processName || ' el trámite'} correctamente.`, 'Se guardó exitosamente')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onStartProcessModal () {
      if (!this.isOnEditMode && this.actionsAvailable.processCanBeStartedByMe) {
        // Nuevo y puedo iniciar
        await this.$refs.lmConfirmationModal.lmShow()
      } else if (!this.isOnEditMode && this.actionsAvailable.processCanBeRequestStartedByMe) {
        // Nuevo y puedo solicitar que lo inicie otro
        this.$bvModal.show('request-start-modal')
      } else if (this.isOnEditMode && this.actionsAvailable.processCanBeStartedByMe) {
        // Edicion y puedo iniciar
        await this.$refs.lmConfirmationModal.lmShow()
      } else if (this.isOnEditMode && this.actionsAvailable.processCanBeRequestStartedByMe) {
        // Edicion y puedo solicitar que lo inicie otro
        this.$bvModal.show('request-start-modal')
      }
    },
    async startProcess () {
      // Validación
      try {
        this.validateStarter()
      } catch (error) {
        return false
      }
      try {
        this.isLoading = true
        let targetEndpoint
        let action
        const data = {
          ...this.form,
          processTypeId: this.processTypeId
        }
        if (!this.isOnEditMode && this.actionsAvailable.processCanBeStartedByMe) {
          // Nuevo y puedo iniciar
          targetEndpoint = '/processes/createandstart'
          action = 'inició'
        } else if (!this.isOnEditMode && this.actionsAvailable.processCanBeRequestStartedByMe) {
          // Nuevo y puedo solicitar que lo inicie otro
          targetEndpoint = '/processes/createandrequeststart'
          action = 'solicitó iniciar'
          data.destination = {
            [this.requestStartType.id]: this.requestStartDestination
            // user: this.requestStartDestination
          }
        } else if (this.isOnEditMode && this.actionsAvailable.processCanBeStartedByMe) {
          // En modo edicion el id es necesario enviarlo
          data.id = this.$route.params.id
          // Edicion y puedo iniciar
          targetEndpoint = '/processes/start'
          action = 'inició'
        } else if (this.isOnEditMode && this.actionsAvailable.processCanBeRequestStartedByMe) {
          // En modo edicion el id es necesario enviarlo
          data.id = this.$route.params.id
          // Edicion y puedo solicitar que lo inicie otro
          targetEndpoint = '/processes/requeststart'
          action = 'solicitó iniciar'
          data.destination = {
            [this.requestStartType.id]: this.requestStartDestination
            // user: this.requestStartDestination
          }
        }
        const res = await commonsApi.axiosPostWrapper(targetEndpoint, data)
        this.lmToastSuccessMessage(`Se ${action} ${this.form?.processName || ' el trámite'} correctamente.`, 'Trámite Iniciado')
        if (this.actionsAvailable.processCanBeStartedByMe) {
          if (this.isOnEditMode) {
            // reload
            await this.loadActionsAvailable()
            await this.loadContentOnEditMode()
          } else {
            this.$router.replace(`/tramites/${res.data.processTypeId}/editar/${res.data._id}`)
          }
        } else {
          this.$router.push('/inbox')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        await commonsApi.axiosPutWrapper(`/processes/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(`Se eliminó ${this.form?.processName || ' el trámite'} correctamente.`, 'Trámite eliminado.')
        this.$router.push('/inbox')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push('/inbox')
    },
    updateForm (event) {
      this.form = Object.assign({}, this.form, event)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async loadContentOnEditMode () {
      if (this.isOnEditMode) {
        try {
          this.isLoading = true
          const process = await commonsApi.axiosGetWrapper(`/processes/${this.$route.params.id}`)
          this.form = process.data
          this.deleted = process.data.deleted
          this.resumeContentLoaded = true
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      }
    },
    async loadRequestStartOptions () {
      try {
        if (this.processTypeInstanceActions) {
          const { area, subarea } = this.processTypeInstanceActions
          if (!area.length && !subarea.length) {
            const areasPromise = commonsApi.axiosGetWrapper('/customer/areas')
            const subareasPromise = commonsApi.axiosGetWrapper('/customer/subareas')
            const [ areas, subareas ] = await Promise.all([areasPromise, subareasPromise])
            this.requestStartOptions.areas = areas.data.items
            this.requestStartOptions.subareas = subareas.data.items
          } else {
            const starterUsers = await commonsApi.axiosGetWrapper('/processtypes/' + this.$route.params.processTypeId + '/starters')
            this.requestStartOptions.users = starterUsers.data.items
            this.requestStartOptions.areas = area.filter(el => el?.action === 'S')
            this.requestStartTypeOptions = []
            if (this.requestStartOptions.areas?.length) {
              this.requestStartTypeOptions.push({
                id: 'area',
                name: 'Areas'
              })
            }
            this.requestStartOptions.subareas = subarea.filter(el => el?.action === 'S')
            if (this.requestStartOptions.subareas?.length) {
              this.requestStartTypeOptions.push({
                id: 'subarea',
                name: 'Subareas'
              })
            }
            if (this.requestStartOptions.users?.length) {
              this.requestStartTypeOptions.push({
                id: 'user',
                name: 'Usuarios'
              })
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async loadActionsAvailable () {
      try {
        let targetEndpoint
        if (!this.isOnEditMode) {
          // nuevo
          targetEndpoint = '/processes/actionsavailableoncreate/' + this.$route.params.processTypeId
        } else {
          // edicion
          targetEndpoint = '/processes/actionsavailable/' + this.$route.params.id
        }
        const actionsAvailable = await commonsApi.axiosGetWrapper(targetEndpoint)
        this.actionsAvailable = actionsAvailable.data
      } catch (error) {
        console.log(error)
      }
    },
    async onTakeProcess () {
      try {
        await this.$refs.lmTakeConfirmationModal.lmShow()
        await commonsApi.axiosPostWrapper('/processes/take', {
          id: this.$route.params.id
        })
        this.lmToastSuccessMessage(`Ha tomado el proceso ${this.form.lumbreStatus.name} correctamente.`, `Operación realizada con éxito.`)
        await this.loadActionsAvailable()
        await this.loadContentOnEditMode()
        // Cargo los tipos de documentos solo si puedo editarlos
        if (this.actionsAvailableComputed.processCanAddDocuments) {
          const allDocTypes = await commonsApi.axiosGetWrapper('/documenttypes/all')
          this.documenttypesOptions = allDocTypes.data.items
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onReject () {
      try {
        this.isLoading = true
        await commonsApi.axiosPostWrapper('/processes/reject', {
          id: this.$route.params.id
        })
        this.lmToastSuccessMessage(`Se rechazó el trámite ${this.form.lumbreStatus.name} correctamente.`, `Operación realizada con éxito.`)
        this.$router.push('/inbox')
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onSearchStarter () {
      this.$refs.peopleSearcher.start()
    }
  },
  async created () {
    try {
      this.initialForm = JSON.stringify(this.form)

      const processType = await commonsApi.axiosGetWrapper(`/processtypes/${this.$route.params.processTypeId}`)
      this.formbuilderId = processType.data.formbuilderId
      this.listbuilderId = processType.data.listbuilderId
      this.processTypeId = processType.data._id
      this.processTypeName = processType.data.typeName
      this.processTadAvailable = processType.data.tadAvailable
      this.processTypePrefix = processType.data.typePrefix
      this.processTypeWorkflow = processType.data.typeWorkflow
      this.published = processType.data.published
      this.instanceStarters = processType.data.instanceStarters
      this.processTypeComments = processType.data?.typeComments || 'always'
      this.processTypeHidecCommentsOnFinished = processType.data?.typeHideCommentsOnFinished || false
      this.processTypeInstanceActions = processType.data?.instanceActions

      if (!this.isOnEditMode && !this.published) {
        EventBus.$emit('lmShowGlobalToast', {
          toastMessage: 'Debes publicar el Tipo de Trámite para poder añadirle Trámites.',
          toastAttributes: {
            title: 'Error',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            solid: true
          }
        })
        this.$router.push('/inbox')
      }
      await this.loadActionsAvailable()
      await this.loadRequestStartOptions()
      await this.loadContentOnEditMode()

      if (this.dataToPersist) {
        this.form = _.cloneDeep(this.dataToPersist)
        this.initialForm = JSON.stringify(this.form)
      } else {
        this.showPeopleSearcher = true
      }

      // Si creé un documento desde un proceso, lo cargo (nuevo)
      if (this.lastDocumentCreated) {
        this.form.documents.push(this.lastDocumentCreated)
      }
    } catch (error) {
      console.log(error)
    }
  },
  mounted () {
    if (!this.isOnEditMode && !this.dataToPersist) {
      this.$refs.peopleSearcher.start()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to?.name !== 'documentos-nuevo') {
      this.clearProcessesStore()
    } else {
      this.setDataToPersist(this.form)
    }
    next()
  }
}
</script>

<style lang="sass" scoped>
  .preview-iframe
    height: 80vh
</style>
